<template>
  <div class="purchasePage">
    <!-- 导航 -->
    <switchCard myTitle="确认订单" ></switchCard>
    <!-- 地址 -->
    <div class="orderDetailAdress" v-if="alladress&&alladress.length!== 0" @click="toAdressList">
        <div class="adreeIcon">
            <img src="../../../assets/adress.png" alt="" class="imgAdress">
        </div>
        <div class="adressContent">
            <div class="namePhone">
                <p>{{ alladress[indexAdress].receiverName }}</p>
                <p class="phoneStyle">{{ alladress[indexAdress].receiverMobile }}</p>
            </div>
            <div class="adressOther">
                {{ alladress[indexAdress].receiverPrivince }} {{ alladress[indexAdress].receiverCity }} {{ alladress[indexAdress].receiverDistrict }}
                {{ alladress[indexAdress].receiverAddress }}
            </div>
        </div>
        <div style="width: 10%;text-align: center;"><p class="towardsTheRight"></p></div>
    </div>
    <!-- 跳转到收货地址-->
    <div  v-else class="noAddress" @click="toAdressList">
        <p>添加收货地址</p>
        <p class="towardsTheRight"></p>
    </div>
    <div style="width: 100%;height: 15px;background-color: #F1F1F1"></div>
    <!-- 商品信息 -->
    <div class="listContent" v-if="detailData">
        <div class="orderAttrBox">
            <div class="orderAttr">
                <div class="orderThumb">
                    <img :src="detailData.mainImage" alt="">
                </div>
                <div class="orderContentTitle">
                    <div class="titleStyle">{{ detailData.subTitle }}</div>
                    <div class="dataSmall" v-if="detailData.productBrandEntity">品牌：{{ detailData.productBrandEntity.brandName }}</div>
                </div>
                <div class="orderPrice">
                    <p>{{shopOrintegral=="shop"?'￥'+detailData.price:'积分：'+detailData.integral}}</p>
                </div>
            </div>
            <div class="numberContent">
                <div>
                    合计：{{shopOrintegral=="shop"?'￥'+detailData.price*number:detailData.integral*number+' 积分' }}
                </div>
                <van-stepper v-model="number" integer/>
            </div>
        </div>
        <div class="sureOrder" @click="sureContent"><van-button type="danger" round size="small">确认订单</van-button></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
import { Dialog } from 'vant';
import switchCard from "./allNav.vue";
export default {
    components:{
        switchCard
    },
    data(){
        return{
            detailData:null, //详情
            alladress:null, //收货地址
            number:1, //商品数量
            indexAdress:0 // 地址
        }
    },
    created(){
        this.datailData();
        this.obtailAdress(); //获取地址
        // 进入页面之后
        this.Event.$on('refresh',()=>{
            this.datailData();
            this.obtailAdress(); //获取地址
            this.indexAdress=0;
        })
        // 选择地址之后返回
        this.Event.$on('myBack',(index)=>{
            this.indexAdress=index;
            this.obtailAdress(); //获取地址
        })
    },
    methods:{
        // 获取商品详情接口
        datailData(){
            this.$http.get(
            this.javalinkTwo +"mmall/product/getProductInfoToAPPHtml?productId="+this.$route.query.id
            )
            .then(res => {
                // console.log(res.data);
                if (res.data.success) {
                    this.detailData = res.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 获取地址 
        obtailAdress(){
            this.$http.get(
                this.javalinkTwo +"mmall/shipping/selectShippingByadmin?typeId="+this.wenOrRong
            )
            .then(res => {
                // console.log(res.data);
                if (res.data.success) {
                    this.alladress = res.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 跳转到我的收货地址
        toAdressList(){
            this.$router.push({path:"/addressList",query:{index:this.indexAdress}})
        },
        // 确认订单接口
		sureContent() {
            console.log(this.number);
			if(this.alladress.length == 0||!this.alladress[this.indexAdress]) {
                Toast('请添加收货地址！');
				return;
            }
            var data={
                userId:window.localStorage.civilizationId,
                typeId: this.wenOrRong,
                productIds: [{ productId:this.$route.query.id, count: this.number }],
                paymentTypeId: '1',
                shippingType: '1', //1是自提地址，发货是2
                shippingId:this.alladress[this.indexAdress].id, //地址id
                totalIntegral:this.shopOrintegral=="shop"?"0":JSON.stringify(parseInt(this.detailData.integral) * parseInt(this.number)), //
                totalPrice:this.shopOrintegral=="shop"?JSON.stringify(parseInt(this.detailData.price) * parseInt(this.number)):"0",
                settlementType: '2'
            }
            this.$http.post(this.javalinkTwo +"mmall/order/addOrderFromCart",data,{headers:{'Content-Type': 'application/json'}})
            .then(res => {
                if(res.data.success){
                    var orderNo = res.data.data.orderNo;
                    Dialog.confirm({
                        message:this.shopOrintegral=="shop"?"下单成功，是否立即购买？":"下单成功，是否立即兑换？",
                    })
                    .then(() => {
                        this.payment(orderNo); //支付
                    })
                    .catch(() => {
                        // on cancel
                    });
                }else{
                    Toast(res.data.message);
                }
            })
            .catch(err => {
                console.log(err);
            });
		},
		// 支付
		payment(orderumber) {
            var data={
                typeId: this.wenOrRong,
                orderNo: orderumber,
            }
            this.$http.post(this.javalinkTwo +"mmall/order/orderIsPay",data,{headers:{'Content-Type': 'application/json'}})
            .then(res => {
                if(res.data.success){
                    var that=this;
                    Dialog.confirm({
                        message:this.shopOrintegral=="shop"?"购买成功！":"兑换成功！",
                        confirmButtonText:"返回商城",
                        cancelButtonText:"查看详情"
                    })
                    .then(() => {
                        that.$router.push({path:"/shoppingMall/commodity"});
                    })
                    .catch(() => {
                        that.$router.push({path:"/shoppingMall/order"});
                        // console.log("查看详情");
                        // on cancel
                    });
                }else{
                    Toast(res.data.message);
                }
            })
            .catch(err => {
                console.log(err);
            });
		}
    }
}
</script>

<style lang="less" scoped>
    .purchasePage{
        width: 100%;
        height: 100%;
    }
    // 商品
    .listContent{
        width: 100%;
        margin-top: 8px;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 34px 8px;
        .sureOrder{
            width: 100%;
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
        }
        .orderAttrBox{
            border-bottom: 1px solid #dddddd;
            padding-bottom: 10px;
        }
        .numberContent{
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content:space-between;
            align-items: center;
        }
        .orderAttr{
            width: 100%;
            height: 64px;
            display: flex;
            -webkit-box-pack: justify;
            -webkit-justify-content: space-between;
            justify-content: space-between;
            margin-top: 4px;
            .orderThumb{
                width: 64px;
                height: 100%;
                border-radius: 1px;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .orderContentTitle{
                width: 50%;
                height: 100%;
                white-space: normal;
                font-size: 12px;
                .titleStyle{
                    display: inline-block;
                    width: 100%;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .dataSmall {
                    font-size: 12px;
                    color: #c8c7cc;
                }
            }
            .orderPrice[data-v-37b4bf9e] {
                width: 20%;
                height: 100%;
                display: -webkit-box;
                display: -webkit-flex;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -webkit-flex-direction: column;
                flex-direction: column;
                -webkit-box-align: end;
                -webkit-align-items: flex-end;
                align-items: flex-end;
                font-size: 12px;
            }
        }
    }
   
    // 地址
    .noAddress {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }
    .towardsTheRight {
        display: block;
        width: 12px;
        height: 12px;
        border-top: 2px solid #ccc;
        border-right: 2px solid #ccc;
        transform: rotate(45deg);
    }
    .orderDetailAdress {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        font-size: 14px;
        padding: 10px 0px;
    }
    .adreeIcon {
        width: 20%;
    }
    .imgAdress {
        width: 100%;
        height: auto;
        object-fit: contain;
    }
    .adressContent {
        width: 65%;
        display: flex;
        flex-direction: column;
    }
    .namePhone {
        font-size: 14px;
        margin-bottom: 10px;
        display:flex;
    }
    .phoneStyle {
        color: #999;
        margin-left: 20px;
    }
    .zipCode {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        image {
            width: 400px;
            height: 450px;
            margin-bottom: 10px;
            // margin: auto;
        }
        i {
            display: block;
            color: #fff;
            position: absolute;
            top: 10px;
            right: 10px;
            width: 25px;
            height: 25px;
            background-image: url("../../../assets/X.png");
            background-size: 100% 100%;
        }
    }
</style>